import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AddTeacherErrorItem {
    index?: number;
    data?: { email?: string; teacher_collaborator_roles?: string };
    errors?: { detail?: string };
}

export interface AddTeacherResponse {
    added?: any[];
    errors?: AddTeacherErrorItem[];
    detail?: string;
}

interface AddTeacherState {
    isLoading: boolean;
    error: string | null;
    success: boolean;
    response: AddTeacherResponse | null;
    isRoleUpdate: boolean;
}

const initialState: AddTeacherState = {
    isLoading: false,
    error: null,
    success: false,
    response: null,
    isRoleUpdate: false,
};

const addTeacherSlice = createSlice({
    name: "addTeacher",
    initialState,
    reducers: {
        setAddTeacherLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setAddTeacherError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        setAddTeacherSuccess: (state, action: PayloadAction<boolean>) => {
            state.success = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setAddTeacherResponse: (state, action: PayloadAction<AddTeacherResponse | null>) => {
            state.response = action.payload;
        },
        setAddTeacherIsRoleUpdate: (state, action: PayloadAction<boolean>) => {
            state.isRoleUpdate = action.payload;
        },
        resetAddTeacher: () => initialState,
    },
});

export const {
    setAddTeacherLoading,
    setAddTeacherError,
    setAddTeacherSuccess,
    setAddTeacherResponse,
    setAddTeacherIsRoleUpdate,
    resetAddTeacher,
} = addTeacherSlice.actions;

export default addTeacherSlice.reducer;
